import React from 'react';
import PropTypes from 'prop-types';
import {
  Pressable,
  StyleSheet,
  View,
} from 'react-native';

const TRACK_WIDTH = 51;
const TRACK_HEIGHT = 31;
const THUMB_SIZE = 27;
const THUMB_INSET = (TRACK_HEIGHT - THUMB_SIZE) / 2;

const AppSwitch = ({
  value,
  onValueChange,
  trackColorOn = '#FF4500',
  trackColorOff = '#767577',
  thumbColor = '#FFFFFF',
  disabled = false,
}) => {
  const handlePress = () => {
    if (disabled) return;
    if (onValueChange) onValueChange(!value);
  };

  return (
    <Pressable onPress={handlePress} disabled={disabled}>
      <View
        collapsable={false}
        style={[styles.container, disabled && styles.disabled]}>
        <View
          style={[
            styles.track,
            {backgroundColor: value ? trackColorOn : trackColorOff},
          ]}
        />
        <View
          style={[
            styles.thumb,
            {
              backgroundColor: thumbColor,
              left: value
                ? TRACK_WIDTH - THUMB_SIZE - THUMB_INSET
                : THUMB_INSET,
            },
          ]}
        />
      </View>
    </Pressable>
  );
};

AppSwitch.propTypes = {
  value: PropTypes.bool.isRequired,
  onValueChange: PropTypes.func,
  trackColorOn: PropTypes.string,
  trackColorOff: PropTypes.string,
  thumbColor: PropTypes.string,
  disabled: PropTypes.bool,
};

const styles = StyleSheet.create({
  container: {
    width: TRACK_WIDTH,
    height: TRACK_HEIGHT,
    position: 'relative',
    justifyContent: 'center',
  },
  track: {
    position: 'absolute',
    top: 0,
    left: 0,
    width: TRACK_WIDTH,
    height: TRACK_HEIGHT,
    borderRadius: TRACK_HEIGHT / 2,
  },
  thumb: {
    position: 'absolute',
    top: THUMB_INSET,
    width: THUMB_SIZE,
    height: THUMB_SIZE,
    borderRadius: THUMB_SIZE / 2,
    shadowColor: '#000',
    shadowOffset: {width: 0, height: 1},
    shadowOpacity: 0.25,
    shadowRadius: 1.5,
    elevation: 2,
  },
  disabled: {
    opacity: 0.5,
  },
});

export default AppSwitch;
